import type { WhitelabelDashboardAccount } from "@nlc/shared-types";
import type { LucideIcon } from "lucide-react";

import { LayersIcon, ListIcon, PanelsTopLeftIcon } from "lucide-react";

import { Button } from "@/components/button";

// const FEEDBACK_PLACEHOLDER = "4.8/5";

type WhitelabelDashboardCardProps = {
  account: WhitelabelDashboardAccount;
  onEnter: (projectId: number) => void;
};

function Metric({
  children,
  icon: Icon,
}: {
  children: string;
  icon: LucideIcon;
}) {
  return (
    <div className="flex flex-1 items-center gap-sm">
      <Icon className="size-4 shrink-0 text-text-quaternary" />
      <span className="text-sm text-text-quaternary">{children}</span>
    </div>
  );
}

export function WhitelabelDashboardCard({
  account,
  onEnter,
}: WhitelabelDashboardCardProps) {
  return (
    <div className="flex flex-col gap-xl rounded-4xl border-1 border-border-secondary bg-bg-primary p-3xl">
      <div className="flex items-start justify-between gap-md">
        <h3 className="text-lg font-semibold text-text-primary">
          {account.accountName}
        </h3>
        <span className="rounded-full border border-utility-brand-200 bg-utility-brand-50 px-md py-xxs text-xs text-utility-brand-700">
          {account.subscriptionPlan ?? "No plan"}
        </span>
      </div>

      <div className="flex flex-col gap-lg p-md">
        <div className="flex items-center justify-between gap-md">
          <Metric icon={PanelsTopLeftIcon}>
            {`Design Slots: ${account.designSlots.active}/${account.designSlots.max}`}
          </Metric>
          <Metric icon={ListIcon}>{`In queue: ${account.inQueue}`}</Metric>
        </div>
        <div className="flex items-center justify-between gap-md">
          <Metric icon={LayersIcon}>
            {`Design completion rate: ${account.completionRate}%`}
          </Metric>
          {/* <Metric icon={StarIcon}>{`Feedback: ${FEEDBACK_PLACEHOLDER}`}</Metric> */}
        </div>
      </div>

      <Button
        className="w-full"
        onPress={() => onEnter(account.projectId)}
        variant="primary"
      >
        Impersonate
      </Button>
    </div>
  );
}
